import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
import { cn } from '@/shadcn-ui/utils';

export default function AlertSmall({
  className,
  fillPrimary = colors.red50,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[16px] w-[16px]', className)}
    >
      <g id="ic-alert-sm">
        <path
          id="Vector (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00009 13.5C11.0377 13.5 13.5001 11.0376 13.5001 8C13.5001 4.96243 11.0377 2.5 8.00009 2.5C4.96253 2.5 2.50009 4.96243 2.50009 8C2.50009 11.0376 4.96253 13.5 8.00009 13.5ZM15.0001 8C15.0001 11.866 11.8661 15 8.00009 15C4.1341 15 1.00009 11.866 1.00009 8C1.00009 4.13401 4.1341 1 8.00009 1C11.8661 1 15.0001 4.13401 15.0001 8Z"
          fill={fillPrimary}
        />
        <path
          id="Ellipse 13"
          d="M9 11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10C8.55228 10 9 10.4477 9 11Z"
          fill={fillPrimary}
        />
        <path
          id="Vector 18 (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 4.25C8.41421 4.25 8.75 4.58579 8.75 5L8.75 8C8.75 8.41421 8.41421 8.75 8 8.75C7.58579 8.75 7.25 8.41421 7.25 8L7.25 5C7.25 4.58579 7.58579 4.25 8 4.25Z"
          fill={fillPrimary}
        />
      </g>
    </svg>
  );
}
